import { t } from "i18next";

export const smartDuration = (time: string): string => {
  if (!time) return "";

  const parts = time.trim().split(/\s+/);
  if (parts.length < 2) return time;

  let durationVal = Number(parts[0]);
  let timeUnit = parts[1].toLowerCase();

  if (isNaN(durationVal)) return time;

  // Convert minutes to hours if it is a multiple of 60
  if (
    (timeUnit === "minute" || timeUnit === "minutes") &&
    durationVal >= 60 &&
    durationVal % 60 === 0
  ) {
    durationVal = durationVal / 60;
    timeUnit = "hours";
  }

  if (timeUnit === "hour" || timeUnit === "hours") {
    return durationVal === 1
      ? `1 ${t("hour")}`
      : `${durationVal} ${t("hours")}`;
  }

  if (timeUnit === "minute" || timeUnit === "minutes") {
    return durationVal === 1
      ? `1 ${t("minute")}`
      : `${durationVal} ${t("minutes")}`;
  }

  return time;
};
